module.exports = __webpack_public_path__ + "img/bg1.f2526363.png";